export default __webpack_public_path__ + "static/media/Spin.d752a0f5.svg";